<template>
   <template v-if="d_data.kemandirian_hantar == 1">
      <div class="grow ">
         <div class="w-flex wrap smd-column" >
           <div class="grow ">
             <table >
              <tbody>
               <tr class="row_data">
                  <td><b>  Tarikh Ujian </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.tarikh}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> % Motiliti Progresif 0 Jam </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.motiliti_0}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> % Motiliti Progresif 1 Jam </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.motiliti_1}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> % Motiliti Progresif 2 Jam </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.motiliti_2}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> % Motiliti Progresif 3 Jam </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.motiliti_3}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> % Motiliti Progresif 4 Jam </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.motiliti_4}}</td>
               </tr>
               </tbody>
            </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
            <table class="table-status">
              <tbody>
               <tr class="row_data">
                  <td><b> Status </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.status_label}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> Catatan </b></td>
                  <td><b>:</b></td>
                  <td>{{form_m.catatan}}</td>
               </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div> 
</template>

<template v-else>
      <w-form class="" v-model="form_m.valid" v-model:errors-count="form_m.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
          	<w-input class="mt4"  label="Tarikh Ujian *" type="date" v-model="form_m.tarikh" :validators="[validators.required]"/>
            <w-input class="mt4"  label="% Motiliti Progresif 0 Jam *" type="number" v-model="form_m.motiliti_0" :validators="[validators.required]"/>
            <w-input class="mt4"  label="% Motiliti Progresif 1 Jam *" type="number" v-model="form_m.motiliti_1" :validators="[validators.required]"/>
            <w-input class="mt4"  label="% Motiliti Progresif 2 Jam *" type="number" v-model="form_m.motiliti_2" :validators="[validators.required]"/>
            <w-input class="mt4"  label="% Motiliti Progresif 3 Jam *" type="number" v-model="form_m.motiliti_3" :validators="[validators.required]"/>
            <w-input class="mt4"  label="% Motiliti Progresif 4 Jam *" type="number" v-model="form_m.motiliti_4" :validators="[validators.required]"/>
          </div>
          <div class="mx2"></div>
          <div class="grow " >
            <w-select class="mt4" :items="status_mp" label="Status *"  v-model="form_m.lkp_status_id"  :validators="[validators.required]" />
            <w-textarea class="mt4"  label="Catatan *"  v-model="form_m.catatan" :validators="[validators.required]" v-if="form_m.lkp_status_id == 24"/>
            <w-textarea class="mt4"  label="Catatan"  v-model="form_m.catatan"  v-else/>
          </div>
        </div>
        <w-flex class="mt3" wrap align-center justify-end>
          <!-- <w-button class="my1" type="submit" :disabled="form_m.valid === false" :loading="form_m.submitted && !form_m.sent" @click="send(2)"> -->
          <w-button class="my1"   :loading="form_m.submitted && !form_m.sent" @click="send(2), onSuccess()">
              <w-icon dark tile class="mr2" >fal fa-save</w-icon> SIMPAN
          </w-button>&nbsp;
          <w-button class="my1" bg-color="success" type="submit" :disabled="form_m.valid === false" :loading="form_m.submitted && !form_m.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button> 
        </w-flex>
      </w-form>
	</template>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_data: [Array, Object],
    
  },
  data() {
    return {
     
      form_m : {
      	lkp_ternakan_id : '',
      	lkp_baka_id : '',
      	se_katalog_id : '',
      	se_pemungutan_id : '',
      	tarikh : '',
      	motiliti_0 : '',
      	motiliti_1 : '',
      	motiliti_2 : '',
      	motiliti_3 : '',
      	motiliti_4 : '',
      	catatan : '',
      	lkp_status_id : '',
        hantar : 2
      	
      },
      data: this.d_data,
      status_mp : [],
      
    }
  },
  methods: {
    send(hantar){
      this.form_m.hantar = hantar
    },
    onSuccess(hantar){
      if(this.form_m.hantar == 1){
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            this.$zcomm.post('se.kawalan.store_kemandirian', {
            	lkp_ternakan_id : this.data.lkp_ternakan_id,
            	lkp_baka_id : this.data.lkp_baka_id,
            	se_katalog_id : this.data.se_katalog_id,
            	se_pemungutan_id : this.data.id,
            	tarikh : this.form_m.tarikh,
            	motiliti_0 : this.form_m.motiliti_0,
            	motiliti_1 : this.form_m.motiliti_1,
            	motiliti_2 : this.form_m.motiliti_2,
            	motiliti_3 : this.form_m.motiliti_3,
            	motiliti_4 : this.form_m.motiliti_4,
            	catatan : this.form_m.catatan,
            	lkp_status_id : this.form_m.lkp_status_id,
              hantar : this.form_m.hantar
            })
            .then(res => {
              if (typeof this.onAfterAdd === "function") {
                this.onAfterAdd()
              }
              this.$zutil.notify ("Rekod telah berjaya disimpan")
              this.$inertia.visit(this.$route('se.kawalan.show',this.data.id)+'?t=1')
            })
          }
        });
      }else{
        this.$zcomm.post('se.kawalan.store_kemandirian', {
        lkp_ternakan_id : this.data.lkp_ternakan_id,
        lkp_baka_id : this.data.lkp_baka_id,
        se_katalog_id : this.data.se_katalog_id,
        se_pemungutan_id : this.data.id,
        tarikh : this.form_m.tarikh,
        motiliti_0 : this.form_m.motiliti_0,
        motiliti_1 : this.form_m.motiliti_1,
        motiliti_2 : this.form_m.motiliti_2,
        motiliti_3 : this.form_m.motiliti_3,
        motiliti_4 : this.form_m.motiliti_4,
        catatan : this.form_m.catatan,
        lkp_status_id : this.form_m.lkp_status_id,
      })
      .then(res => {
        if (typeof this.onAfterAdd === "function") {
          this.onAfterAdd()
        }
        this.$zutil.notify ("Rekod telah berjaya disimpan")
        this.$inertia.visit(this.$route('se.kawalan.show',this.data.id)+'?t=1')
      })
      }
      
    },

    getStatusMp(){
      
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
        this.status_mp = res
      })
    },

   

    getData(){
      this.$zcomm.get(this.api_service + 'se_pemungutan/kemandirian/'+this.data.id, {}).then(res => {
        if(res.s == 1){
          this.form_m = res
        }
      })
    },

    
  
  },

  watch: {

  },
  mounted() {
    
   	this.getStatusMp()
   	this.getData()
    
  }
    
}
</script>
